var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('Home'),_c('About'),_c('Skills'),_c('Contact'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","id":"scroll-up"}},[_c('i',{staticClass:"fa fa-home",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }